<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="accessListContainer"
  role="region"
  [attr.aria-label]="'SDE_MANAGE_USERS' | xdaTranslate">
  <div class="row">
    <div class="col-md-12">
      <h3 class="page-title" [xdaTranslate]="'SDE_MANAGE_USERS'"></h3>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      @if (accessListUsers && accessListUsers.length) {
        <form #f="ngForm" class="search-wrapper">
          <div
            class="input-group search-group"
            [ngClass]="{ 'input-group-is-invalid': !searchIsValid }">
            <input
              id="userSearch"
              [(ngModel)]="searchTerm"
              name="userSearch"
              type="text"
              class="form-control"
              (keyup)="validateSearch($event)"
              (blur)="validateSearch($event)"
              [placeholder]="searchPlaceholder"
              [minlength]="searchMinLength" />
            @if (showClearSearch) {
              <div class="input-group-append">
                <button
                  (click)="clearSearch()"
                  type="button"
                  class="xrx-btn btn-short btn-primary xgl-clear_all"
                  [ngbTooltip]="clearTooltip"></button>
              </div>
            }
          </div>
          <div
            class="invalid-feedback"
            [ngClass]="{ 'd-block': !searchIsValid }"
            [xdaTranslate]="'SDE_ENTERT_LEAST_2'"
            [formatValues]="searchMinLength.toString()"></div>
        </form>
      }
    </div>
    <div class="action-buttons col-12 d-flex justify-content-end">
      @if (accessListUsers && accessListUsers.length) {
        <span class="flex-grow-1 select-all-label title">{{
          selectAllLabel
        }}</span>
      }
      <div class="button-wrapper">
        @if (isInviteEnabled()) {
          <button
            type="button"
            class="xrx-btn btn-secondary"
            (click)="inviteUser()">
            <span class="btn-label" [xdaTranslate]="'SDE_INVITE'"></span>
          </button>
        }
        @if (!isSubscriptionExpired()) {
          <button
            type="button"
            class="xrx-btn btn-secondary"
            (click)="editRole()"
            [disabled]="!canEnable()">
            <span class="btn-label" [xdaTranslate]="'SDE_EDIT_ROLE'"></span>
          </button>
        }
        <button
          type="button"
          class="xrx-btn btn-secondary"
          (click)="displayAlert()"
          [disabled]="!canEnable()">
          <span class="btn-label" [xdaTranslate]="'SDE_REMOVE'"></span>
        </button>
      </div>
    </div>
  </div>
  @if (accessListUsers && accessListUsers.length) {
    <div class="table-responsive show-non-mobile">
      <table class="table table-sort">
        <thead>
          <tr>
            <th scope="col" class="check">
              @if (accessListUsers && accessListUsers.length) {
                <xrx-checkbox
                  class="all-job-checkbox mb-2"
                  [name]="'all-job-checkbox'"
                  [(checkBoxValue)]="selectAll"
                  [(isPartial)]="isPartial"
                  (toggle)="toggleAll($event)"></xrx-checkbox>
              }
            </th>
            <th
              sortableCol="userLastName"
              direction="asc"
              [initialSort]="true"
              (sort)="setSortParams($event)"
              scope="col"
              class="sort-active user-name">
              <span xdaTranslate>SDE_NAME3</span>
            </th>
            <th
              sortableCol="userEmail"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="user-email">
              <span xdaTranslate>SDE_EMAIL2</span>
            </th>
            <th
              sortableCol="userStatusTranslated"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="user-status">
              <span xdaTranslate>SDE_STATUS</span>
            </th>
            <th
              sortableCol="accessListRoleTranslated"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="user-role">
              <span xdaTranslate>SDE_ROLE</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (
            user of accessListUsers
              | tableFilter
                : searchTerm
                : searchFilterColumns
                : searchMinLength
                : tableFilterMetadata
              | tableSort: direction : column : type
              | slice: (page - 1) * pageSize : page * pageSize;
            track user;
            let i = $index;
            let last = $last;
            let first = $first
          ) {
            <tr (click)="rowClicked($any(user))">
              <td class="check">
                <xrx-checkbox
                  class="tos-checkbox"
                  [(checkBoxValue)]="$any(user).checked"
                  [name]="$any(user).userId"
                  (toggle)="onChecked()"
                  stop-event-propagation></xrx-checkbox>
              </td>
              <td class="user-name">
                @if ($any(user).userFirstName) {
                  <span
                    >{{ $any(user).userLastName }},
                    {{ $any(user).userFirstName }}</span
                  >
                }
              </td>
              <td class="user-email">
                <span [textContent]="$any(user).userEmail"></span>
              </td>
              <td class="user-status">
                <span
                  [xdaTranslate]="$any(user).userStatus.sdekey"
                  style="margin-right: 16px"></span>
                @if (
                  $any(user).userStatus.value === 'Invited' &&
                  !isSubscriptionExpired()
                ) {
                  <button
                    type="button"
                    class="xrx-btn btn-sm btn-secondary"
                    (click)="
                      displayResendAlert(
                        $any(user).userId,
                        $any(user).userEmail
                      )
                    "
                    stop-event-propagation>
                    <span
                      class="btn-label"
                      [xdaTranslate]="'SDE_RESEND'"></span>
                  </button>
                }
              </td>
              <td class="user-role">
                <span
                  [xdaTranslate]="
                    $any(user).accessListRole == 'User'
                      ? 'SDE_USER'
                      : 'SDE_MANAGER'
                  "></span>
              </td>
            </tr>
          }
          <tr class="no-results">
            <td
              class="text-center"
              colspan="5"
              [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  <div class="show-non-mobile">
    @if (accessListUsers && accessListUsers.length && displayPagination) {
      <xrx-pagination
        [(page)]="page"
        [(pageSize)]="pageSize"
        [initialPageSize]="initialPageSize"
        [pageSizeList]="pageSizeList"
        [collectionSize]="tableFilterMetadata.count"
        class="d-flex justify-content-center justify-content-sm-end">
      </xrx-pagination>
    }
  </div>
  @if (accessListUsers && accessListUsers.length) {
    <div class="show-mobile">
      <div class="select-all-header">
        <table class="table mb-0">
          <thead>
            <tr>
              <th scope="col" class="check">
                @if (accessListUsers && accessListUsers.length) {
                  <xrx-checkbox
                    class="all-job-checkbox"
                    [name]="'all-job-checkbox'"
                    [(checkBoxValue)]="selectAll"
                    [(isPartial)]="isPartial"
                    label="SDE_USERS"
                    (toggle)="toggleAll($event)"></xrx-checkbox>
                }
              </th>
            </tr>
          </thead>
        </table>
      </div>
      @for (
        user of accessListUsers
          | tableFilter
            : searchTerm
            : ['userFirstName', 'userLastName', 'userEmail']
            : searchMinLength
            : tableFilterMetadata
          | slice: (page - 1) * pageSize : page * pageSize;
        track user;
        let i = $index;
        let last = $last;
        let first = $first
      ) {
        <div (click)="rowClicked($any(user))" class="row user-record">
          <div class="col-1">
            <xrx-checkbox
              class="tos-checkbox"
              [(checkBoxValue)]="$any(user).checked"
              [name]="$any(user).userId"
              (toggle)="onChecked()"
              stop-event-propagation></xrx-checkbox>
          </div>
          <div class="col-10">
            <ul>
              <li>
                @if ($any(user).userFirstName) {
                  <span class="user-name"
                    >{{ $any(user).userLastName }},
                    {{ $any(user).userFirstName }}</span
                  >
                }
              </li>
              <li><span [textContent]="$any(user).userEmail"></span></li>
              <li>
                <span
                  [xdaTranslate]="$any(user).userStatus.sdekey"
                  style="margin-right: 16px"></span>
              </li>
              <li>
                <span
                  [xdaTranslate]="
                    $any(user).accessListRole == 'User'
                      ? 'SDE_USER'
                      : 'SDE_MANAGER'
                  "></span>
              </li>
              @if (
                $any(user).userStatus.value === 'Invited' &&
                !isSubscriptionExpired()
              ) {
                <li class="resend-btn">
                  <button
                    type="button"
                    class="xrx-btn btn-sm btn-secondary col-6"
                    (click)="
                      displayResendAlert(
                        $any(user).userId,
                        $any(user).userEmail
                      )
                    "
                    stop-event-propagation>
                    <span
                      class="btn-label"
                      [xdaTranslate]="'SDE_RESEND'"></span>
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>
      }
      <div class="user-record text-center no-results">
        <p class="pb-3 m-0" [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></p>
      </div>
    </div>
  }
  <div class="show-mobile">
    @if (accessListUsers && accessListUsers.length && displayPagination) {
      <xrx-pagination
        [(page)]="page"
        [(pageSize)]="pageSize"
        [initialPageSize]="initialPageSize"
        [pageSizeList]="pageSizeList"
        [collectionSize]="tableFilterMetadata.count"
        class="d-flex justify-content-center justify-content-sm-end">
      </xrx-pagination>
    }
  </div>
</div>
